/* eslint-disable @angular-eslint/component-selector */
import { ChangeDetectionStrategy, Component } from '@angular/core'

import { CmpTitle } from 'app/core/cms/generated/api-types'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'h2[pai-cmp-title]',
  template: '{{ data().title }}',
  styleUrls: ['./cmp-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [{ provide: CmsBlock, useExisting: CmpTitleComponent }],
})
export class CmpTitleComponent extends CmsBlock<CmpTitle> {
  readonly __typename = 'CmpTitle'
}
